import SponsorUpdateModal from "./SponsorUpdateModal"

export default SponsorUpdateModal
